import React from 'react';
import {connect} from 'react-redux';
import './styles.scss';
import Logo from '../../assets/logo-white-2.png';
import {begin} from '../../utils/beforeunload';
import Introduksjon from '../../components/Introduksjon';
import Orddiktat from '../../components/Orddiktat';
import Ordkjedetesten from '../../components/Ordkjedetesten';
import Tulleordtesten from '../../components/Tulleordtesten';
import Skrivehastighet from '../../components/Skrivehastighet';
import Leseproven from '../../components/Leseproven';
import Ordforstaelse from '../../components/Ordforstaelse';
import SprakForstaelse from 'components/SprakForstaelse';
import Ferdig from '../../components/Ferdig';
import getTestInfo from '../../api/getTestInfo';
import getUserInfo from '../../api/getUserInfo';
import getUserGrade from '../../api/getUserGrade';
import setAnamneseVersion from '../../api/setAnamneseVersion';
import {setTestCandidateGrade} from '../../actions/index';

const TEST_ORDER = [
  { id: 3, Comp: Tulleordtesten },
  { id: 7, Comp: SprakForstaelse },
  { id: 2, Comp: Ordkjedetesten },
  { id: 1, Comp: Orddiktat },
  { id: 4, Comp: Skrivehastighet },
  { id: 5, Comp: Leseproven },
  { id: 6, Comp: Ordforstaelse },
];

const testSteps = [
  Introduksjon,
  Tulleordtesten,
  SprakForstaelse,
  Ordkjedetesten,
  Orddiktat,
  Skrivehastighet,
  Leseproven,
  Ordforstaelse,
  Ferdig,
];

const renderRemainingTests = [];

class ScreeningTest extends React.Component {
	constructor() {
		super();

		this.state = {
			isLoggedIn: false,
			includeAnamnese: false,
			 remainingSteps: null,
		};
	}

	componentDidMount() {
    getTestInfo().then((results) => {
      const exclusiveTests = results.exclusiveTests || {}; // not taken
      const grade = results.grade;

      // Build remaining steps in YOUR desired order
      const remainingIds = {};
      Object.values(exclusiveTests).forEach(function (v) {
        remainingIds[String(v)] = true; // object-as-set for old Node safety
      });

      var steps = null;

      if (Object.keys(remainingIds).length) {
        steps = TEST_ORDER
          .filter(function (t) { return remainingIds[String(t.id)]; })
          .map(function (t) { return t.Comp; })
          .concat([Ferdig]);

        getUserGrade().then((r) => {
          this.props.onSetTestCandidateGrade(r);
        });
      } else if (grade) {
        // Fresh start (but still use the same canonical order)
        steps = TEST_ORDER.map(function (t) { return t.Comp; }).concat([Ferdig]);
        this.props.onSetTestCandidateGrade(grade);
      }

      // Save computed steps (if any) so render uses them
      if (steps) {
        this.setState({ remainingSteps: steps });
      }

      setAnamneseVersion().then((response) => {
        this.setState({ includeAnamnese: response === 'True' });
      });

      getUserInfo().then((response) => {
        if (response.ok) {
          this.setState({ isLoggedIn: true });
          begin();
        } else {
          window.location.href = `/`;
        }
      });
    });
  }


	render() {
		if (!this.state.isLoggedIn) return null;

		const {currentStepIndex} = this.props;

	  var stepsToUse =
      (this.state.remainingSteps && this.state.remainingSteps.length)
        ? this.state.remainingSteps
        : testSteps;

		var CurrentStep = stepsToUse[currentStepIndex];

		return (
      <div>
        <header className="lit-header">
          <h1 className="lit-logo">
            <img className="lit-logo__img" src={Logo} alt="literate-logo" />
          </h1>
        </header>
        <div className="lit-wrapper--article text-center">
          <CurrentStep includeLongAnamnese={this.state.includeAnamnese} />
        </div>
      </div>
    );
	}
}

const mapStateToProps = (state) => {
	const {currentStepIndex} = state;

	return {
		currentStepIndex,
	};
};
const mapDispatchToProps = {
	onSetTestCandidateGrade: setTestCandidateGrade,
};

export default connect(mapStateToProps, mapDispatchToProps)(ScreeningTest);
